import Errors from './Errors';

export default class FormService {
    constructor(data) {
        this.originalData = data;
        this.isLoading = false;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    submit(type, url) {
        this.runLoading();
        type = type.toLowerCase();
        return new Promise((resolve, reject) => {
            axios[type](url, this.data())
                .then(response => {
                    this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(errors => {
                    if (errors.response) {
                        this.onFail(errors.response.data);
                        reject(errors.response.data.errors);
                    } else {
                        this.onFail(errors);
                        reject(errors);
                    }
                });
        });
    }

    post(url, params = {}) {
        return this.submit('post', url, params);
    }

    put(url, params = {}) {
        return this.submit('put', url, params);
    }

    onSuccess() {
        this.stopLoading();
    }

    onFail(errors) {
        this.stopLoading();
        Vue.notify({
            type: 'error',
            group: 'foo',
            title: 'ООПС!!!',
            text: errors.message
        });
        this.errors.record(errors.errors);
    }

    reset() {
        for (let field in this.originalData) {
            this[field] = null;
        }

        this.errors.clear();
    }

    setData(data) {
        for (let property in data) {
            this[property] = data[property];
        }
    }

    runLoading() {
        this.isLoading = true;
    }

    stopLoading() {
        this.isLoading = false;
    }
}
